export class PageStyle {
    id: number;
    bgColor: string="#ffffff";
    bgImage: string="";
    logoImage:string="";
    w_logo_image:string="";
}